import R_Define from './R_Define';

const init = () => {
    const defaultCodeObj = () => ({
        target: '',
        parameter: []
    });
    const defaultScopeObj = type => ({
        target: type,
        test: ''
    });
    const defaultParamObj = openQuote => ({
        type: openQuote ? 'string' : 'number',
        value: ''
    });

    return class R_Parser {
        constructor(code) {
            this.state = {
                // 괄호
                openParam: false,
                paramIdx: 0,
                // 따옴표
                openQuote: false,
                quoteType: '',
                // if
                openIf: false,
                // if 문 괄호
                openIfBracket: false,
                // if 문 화살괄호
                openIfScope: false,
                ifScopeCode: '',
                // else
                openElseScope: false,
                elseScopeCode: '',
                // scope on scope
                scopeOnScope: false,
                scopeOnScopeCnt: 0,
                // while
                openWhile: false,
                openWhileBracket: false,
                whileScopeCode: '',
                openWhileScope: false
            };

            this.init(code);

            return this.parse();
        }


        // 코드 파싱 기본 세팅
        init(code) {
            this.code = code;
            this.codeSet = [];
            this.resetNowCodeObj();
            this.resetState();
        }

        // state 초기화
        resetState() {
            Object.keys(this.state).forEach((key) => {
                const value = this.state[key];
                switch (typeof value) {
                    case 'string': {
                        this.state[key] = '';
                        break;
                    }
                    case 'number': {
                        this.state[key] = 0;
                        break;
                    }
                    case 'boolean': {
                        this.state[key] = false;
                        break;
                    }
                    default:
                }
            });
        }

        // 현재 코드 오브젝트 초기화
        resetNowCodeObj() {
            this.nowCodeObj = defaultCodeObj();
        }

        // 파라미터 오브젝트 등록
        startParam() {
            this.state.openParam = true;
        }

        // 파라미터 추가
        addParam() {
            this.nowParamObj = defaultParamObj(this.state.openQuote);
            this.nowCodeObj.parameter[this.state.paramIdx++] = this.nowParamObj;
        }

        // 파라미터 코드 추가
        appendParamCode(e) {
            if (!this.nowParamObj) this.addParam();
            this.nowParamObj.value += e;
        }

        // 파라미터 종료
        endParam() {
            this.nowParamObj = null;
            this.state.openParam = false;
        }

        // if 코드 오브젝트 등록
        startIf() {
            this.nowCodeObj = defaultScopeObj('if');
            this.state.openIf = true;
        }

        // if 문 종료
        endIf() {
            this.nowCodeObj.scopeCode = new R_Parser(this.state.ifScopeCode);
            this.resetState();

            this.appendCodeSet();
        }

        // if 문 코드 추가
        appendIfCode(e) {
            this.state.ifScopeCode += e;
        }

        // if 문 조건 코드 추가
        appendIfTest(e) {
            this.nowCodeObj.test += e;
        }

        // if 문 조건 종료
        endIfBracket() {
            this.state.openIfBracket = false;
        }

        // 코드 셋 추가
        appendCodeSet() {
            this.codeSet.push(this.nowCodeObj);
            this.resetNowCodeObj();
        }

        // else 문 종료
        endElse() {
            this.nowCodeObj.elseCode = new R_Parser(this.state.elseScopeCode);
            this.state.elseScopeCode = '';
            this.state.openElseScope = false;
        }

        // else 문 코드 추가
        appendElseCode(e) {
            this.state.elseScopeCode += e;
        }

        // 따옴표 상태 설정
        setQuoteState(e) {
            let isInQuote = false;
            if (this.state.openQuote) {
                if (this.state.quoteType === e) {
                    this.state.openQuote = false;
                } else {
                    isInQuote = true;
                }
            } else {
                this.state.openQuote = true;
                this.state.quoteType = e;
            }
            return isInQuote;
        }

        startWhile() {
            this.nowCodeObj = defaultScopeObj('while');
            this.state.openWhile = true;
        }

        appendWhileCode(e) {
            this.state.whileScopeCode += e;
        }

        // text 코드 -> 코드 셋
        parse() {
            const codes = Array.from(this.code);

            while (codes.length) {
                const e = codes.shift();

                switch (this.status) {
                    case R_Define.PARSER_STATUS.DEFAULT: { // 기본
                        switch (e) {
                            case ';': {
                                this.appendCodeSet();
                                this.resetState();
                                break;
                            }
                            case '(': {
                                this.startParam();
                                break;
                            }
                            case 'i': {
                                if (
                                    !this.nowCodeObj.target.length
                                    && codes[0] === 'f'
                                ) {
                                    this.startIf();
                                } else {
                                    this.nowCodeObj.target += e;
                                }
                                break;
                            }
                            case 'w': {
                                if (
                                    !this.nowCodeObj.target.length
                                    && `${e}${codes.slice(0, 4).join('')}` === R_Define.PARSER_KEYWORD.WHILE
                                ) {
                                    codes.splice(0, 4);
                                    this.startWhile();
                                } else {
                                    this.nowCodeObj.target += e;
                                }
                                break;
                            }
                            default: {
                                this.nowCodeObj.target += e.trim();
                            }
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.PARAM: { // 함수 파라미터
                        switch (e) {
                            case ')': {
                                if (
                                    this.state.openQuote
                                    || (
                                        this.nowParamObj
                                        && this.nowParamObj.value.endsWith('].getValue(')
                                    )
                                ) {
                                    this.appendParamCode(e);
                                } else {
                                    this.endParam();
                                }
                                break;
                            }
                            case ',': {
                                if (this.state.openQuote) {
                                    this.appendParamCode(e);
                                } else {
                                    this.addParam();
                                }
                                break;
                            }
                            case '\'':
                            case '`':
                            case '"': {
                                const a = this.setQuoteState(e);
                                if (a) {
                                    this.appendParamCode(e);
                                }
                                break;
                            }
                            default: {
                                this.appendParamCode(e);
                            }
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.IF: { // if 문
                        switch (e) {
                            case '(': {
                                this.state.openIfBracket = true;
                                break;
                            }
                            case '{': {
                                this.state.openIfScope = true;
                                break;
                            }
                            default:
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.IF_BRACKET: { // if 문 조건
                        switch (e) {
                            case ')': {
                                if (this.nowCodeObj.test.endsWith('\'].getValue(')) {
                                    this.appendIfTest(e);
                                } else {
                                    this.endIfBracket();
                                }
                                break;
                            }
                            default: {
                                this.appendIfTest(e.trim());
                            }
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.IF_SCOPE: { // if 문 (화살괄호 이후 내용)
                        switch (e) {
                            case '}': {
                                this.appendIfCode(e);
                                if (!this.state.openQuote) {
                                    this.state.scopeOnScopeCnt--;
                                    if (
                                        !this.state.scopeOnScope
                                        || this.state.scopeOnScopeCnt < 0
                                    ) {
                                        if (codes.slice(0, 5).join('').trim() === R_Define.PARSER_KEYWORD.ELSE) {
                                            codes.splice(0, 7);
                                            this.state.scopeOnScope = false;
                                            this.state.scopeOnScopeCnt = 0;
                                            this.state.openElseScope = true;
                                        } else {
                                            this.endIf();
                                        }
                                    }
                                }
                                break;
                            }
                            case '\'':
                            case '`':
                            case '"': {
                                this.setQuoteState(e);
                                this.appendIfCode(e);
                                break;
                            }
                            case '{': {
                                if (!this.state.openQuote) {
                                    this.state.scopeOnScope = true;
                                    this.state.scopeOnScopeCnt++;
                                }
                                this.appendIfCode(e);
                                break;
                            }
                            default: {
                                this.appendIfCode(e);
                            }
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.ELSE_SCOPE: { // else 문
                        switch (e) {
                            case '}': {
                                this.appendElseCode(e);
                                if (!this.state.openQuote) {
                                    this.state.scopeOnScopeCnt--;
                                    if (
                                        !this.state.scopeOnScope
                                        || this.state.scopeOnScopeCnt < 0
                                    ) {
                                        if (codes.slice(0, 5).join('').trim() === R_Define.PARSER_KEYWORD.ELSE) {
                                            this.state.scopeOnScopeCnt++;
                                        } else {
                                            this.endElse();
                                            this.endIf();
                                        }
                                    }
                                }
                                break;
                            }
                            case '\'':
                            case '`':
                            case '"': {
                                this.setQuoteState(e);
                                this.appendElseCode(e);
                                break;
                            }
                            case '{': {
                                if (!this.state.openQuote) {
                                    this.state.scopeOnScope = true;
                                    this.state.scopeOnScopeCnt++;
                                }
                                this.appendElseCode(e);
                                break;
                            }
                            default: {
                                this.appendElseCode(e);
                            }
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.WHILE: { // while 문
                        switch (e) {
                            case '(': {
                                this.state.openWhileBracket = true;
                                break;
                            }
                            case '{': {
                                this.state.openWhileScope = true;
                                break;
                            }
                            default:
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.WHILE_BRACKET: { // while 문 조건
                        switch (e) {
                            case ')': {
                                this.state.openWhileBracket = false;
                                break;
                            }
                            default:
                        }
                        break;
                    }
                    case R_Define.PARSER_STATUS.WHILE_SCOPE: {
                        switch (e) {
                            case '{': {
                                if (!this.state.openQuote) {
                                    this.state.scopeOnScope = true;
                                    this.state.scopeOnScopeCnt++;
                                }
                                this.appendWhileCode(e);
                                break;
                            }
                            case '}': {
                                this.appendWhileCode(e);
                                if (!this.state.openQuote) {
                                    this.state.scopeOnScopeCnt--;
                                    if (
                                        !this.state.scopeOnScope
                                        || this.state.scopeOnScopeCnt < 0
                                    ) {
                                        this.openWhileScope = false;
                                        this.nowCodeObj.scopeCode = new R_Parser(this.state.whileScopeCode);
                                        this.resetState();

                                        this.appendCodeSet();
                                    }
                                }
                                break;
                            }
                            case '\'':
                            case '`':
                            case '"': {
                                this.setQuoteState(e);
                                this.appendWhileCode(e);
                                break;
                            }
                            default: {
                                this.appendWhileCode(e);
                            }
                        }
                        break;
                    }
                    default:
                }
            }

            return this.codeSet;
        }

        get status() {
            let status;

            if (this.state.openWhileScope) {
                status = R_Define.PARSER_STATUS.WHILE_SCOPE;
            } else if (this.state.openWhileBracket) {
                status = R_Define.PARSER_STATUS.WHILE_BRACKET;
            } else if (this.state.openWhile) {
                status = R_Define.PARSER_STATUS.WHILE;
            } else if (this.state.openElseScope) {
                status = R_Define.PARSER_STATUS.ELSE_SCOPE;
            } else if (this.state.openIfScope) {
                status = R_Define.PARSER_STATUS.IF_SCOPE;
            } else if (this.state.openParam) {
                status = R_Define.PARSER_STATUS.PARAM;
            } else if (this.state.openIfBracket) {
                status = R_Define.PARSER_STATUS.IF_BRACKET;
            } else if (this.state.openIf) {
                status = R_Define.PARSER_STATUS.IF;
            } else {
                status = R_Define.PARSER_STATUS.DEFAULT;
            }

            return status;
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/util/R_Parser.js